import { PublicLayout } from "@/components/PublicLayout";
import { Center, Heading } from "@chakra-ui/react";

export default function Page() {
  return (
    <PublicLayout>
      <Center w="full" h="full">
        <Heading as="h1">404 - Page Not Found</Heading>
      </Center>
    </PublicLayout>
  );
}
